import React from 'react'

export default function hotline() {
    return (
        <div className="section--4">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 text">
                        <h2>Vous avez un projet,<br></br>
                            nous avons les experts </h2>
                        <p>Échangeons ensemble,<br></br>
                            c’est simple et sans engagement</p>
                        <a href="#" className="btn white">
                            CONTACTEZ NOUS
                        </a>
                    </div>
                    <div className="col-md-6 right">
                        <div className="icon"><img src={require("../../../styles/medias/images/projet-icon-tel.svg")} /></div>
                        <div className="tel">
                            0522 42 95 95
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
